import { gql } from '@apollo/client'

export const CREATE_CURBO_SPOT = gql`
  mutation createCurboSpot($input: CreateCurboSpotInput!) {
    data: createCurboSpot(input: $input) {
      id
    }
  }
`
